// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { WorkflowProcess } from "./WorkflowProcess";
import {
  WorkflowProcessFromJSON,
  WorkflowProcessFromJSONTyped,
  WorkflowProcessToJSON,
  WorkflowProcessToJSONTyped,
} from "./WorkflowProcess";

/**
 *
 * @export
 * @interface Workflow
 */
export interface Workflow {
  /**
   *
   */
  id: string;
  /**
   *
   */
  slug: string;
  /**
   *
   */
  subtitle: string;
  /**
   *
   */
  description: string;
  /**
   *
   */
  processes: Array<WorkflowProcess>;
}

/**
 * Check if a given object implements the Workflow interface.
 */
export function instanceOfWorkflow(value: object): value is Workflow {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("slug" in value) || value["slug"] === undefined) return false;
  if (!("subtitle" in value) || value["subtitle"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined) return false;
  if (!("processes" in value) || value["processes"] === undefined) return false;
  return true;
}

export function WorkflowFromJSON(json: any): Workflow {
  return WorkflowFromJSONTyped(json, false);
}

export function WorkflowFromJSONTyped(json: any, ignoreDiscriminator: boolean): Workflow {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    slug: json["slug"],
    subtitle: json["subtitle"],
    description: json["description"],
    processes: (json["processes"] as Array<any>).map(WorkflowProcessFromJSON),
  };
}

export function WorkflowToJSON(json: any): Workflow {
  return WorkflowToJSONTyped(json, false);
}

export function WorkflowToJSONTyped(
  value?: Workflow | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    slug: value["slug"],
    subtitle: value["subtitle"],
    description: value["description"],
    processes: (value["processes"] as Array<any>).map(WorkflowProcessToJSON),
  };
}
